import { cn } from "@/lib/utils";

/** Command/combobox rows (single nudge only — never also on a parent wrapper). */
const SEARCH_COMMAND_ICON_NUDGE = "translate-y-px";

/** Icons overlaid on inputs; text cap height sits slightly below box center. */
const SEARCH_OVERLAY_ICON_NUDGE = "translate-y-0.5";

/** Icon inside {@link CommandInput} and other inline flex search rows. */
export const searchCommandIconClassName = cn(
  "h-4 w-4 shrink-0 opacity-50",
  SEARCH_COMMAND_ICON_NUDGE
);

/** Icon overlaid on the left of an input (with matching `pl-9` / `pl-10` on the input). */
export const searchInputOverlayIconClassName = cn(
  "pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 shrink-0 -my-2.5",
  SEARCH_OVERLAY_ICON_NUDGE
);

export function searchInputOverlayIconClass(left = "left-3", tone = "text-muted-foreground") {
  return cn(searchInputOverlayIconClassName, left, tone);
}
